// const SMS_RSA_PUBLIC_KEY = 
//   "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC4EKqKRPmifbZuxC3655lHQvpBjV9e/zJwTLCA/JhfsLxrxv1bGtP1XB6YiqsGLnumdAqtQx2JyZ/QYLOb2KW4efLY+luWk6sPhcNPznvr4p+DWxNTu/FWBxjL3scW+G0uVTprBfI5CvS7jpR8S2cFVxHXSg09H/mrY8x3cyGKpQIDAQAB";

const SMS_RSA_PUBLIC_KEY = process.env.REACT_APP_MOBILE_AES_KEY || "";

const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();

function arrayBufferToBase64(buffer) {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

async function importRSAPublicKey(pemBase64) {
  const derBuffer = base64ToArrayBuffer(pemBase64);
  return window.crypto.subtle.importKey(
    "spki",
    derBuffer,
    {
      name: "RSA-OAEP",
      hash: "SHA-256",
    },
    true,
    ["encrypt"]
  );
}

export async function encryptSMSRequest(payload) {
  const aesKey = await window.crypto.subtle.generateKey(
    {
      name: "AES-GCM",
      length: 256,
    },
    true,
    ["encrypt", "decrypt"]
  );

  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const payloadString = JSON.stringify(payload);
  const encryptedPayloadBuffer = await window.crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv,
    },
    aesKey,
    textEncoder.encode(payloadString)
  );

  const rawAesKey = await window.crypto.subtle.exportKey("raw", aesKey);
  const rsaPublicKey = await importRSAPublicKey(SMS_RSA_PUBLIC_KEY);
  const encryptedKeyBuffer = await window.crypto.subtle.encrypt(
    {
      name: "RSA-OAEP",
    },
    rsaPublicKey,
    rawAesKey
  );

  return {
    encryptedPayload: arrayBufferToBase64(encryptedPayloadBuffer),
    encryptedKey: arrayBufferToBase64(encryptedKeyBuffer),
    signature: arrayBufferToBase64(encryptedKeyBuffer),
    iv: arrayBufferToBase64(iv),
    _aesKey: aesKey,
  };
}

export async function decryptSMSResponse(encryptedResponseBase64, responseIvBase64, aesKey) {
  if (!encryptedResponseBase64 || !responseIvBase64 || !aesKey) {
    throw new Error("Missing response payload, IV, or original AES key.");
  }

  const encryptedResponseBuffer = base64ToArrayBuffer(encryptedResponseBase64);
  const responseIv = base64ToArrayBuffer(responseIvBase64);

  const decryptedBuffer = await window.crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: responseIv,
    },
    aesKey,
    encryptedResponseBuffer
  );

  const decryptedString = textDecoder.decode(decryptedBuffer);
  return JSON.parse(decryptedString);
}
